import { Controller } from "@hotwired/stimulus"

const DEFAULT_TAB = "account"
const TAB_CLASSES = {
  "tab-active": ["text-teal-700", "border-b-2", "border-teal-600"],
  "tab-inactive": ["text-gray-600"],
} as const

export default class SettingsTabsController extends Controller<HTMLElement> {
  static targets = ["tab", "panel"]

  declare readonly tabTargets: HTMLAnchorElement[]
  declare readonly panelTargets: HTMLElement[]

  connect(): void {
    this.activate(this.activeTabName())
    window.addEventListener("hashchange", this.handleHashChange)
  }

  disconnect(): void {
    window.removeEventListener("hashchange", this.handleHashChange)
  }

  show(event: Event): void {
    const link = event.currentTarget as HTMLAnchorElement
    const name = this.tabName(link)
    if (name === this.activeTabName()) return

    history.replaceState(null, "", "#" + name)
    this.activate(name)
  }

  private handleHashChange = (): void => {
    this.activate(this.activeTabName())
  }

  private activeTabName(): string {
    const hash = window.location.hash.replace(/^#/, "")
    const panelNames = this.panelTargets.map((panel) => panel.dataset.panel)
    return hash && panelNames.includes(hash) ? hash : DEFAULT_TAB
  }

  private tabName(link: HTMLAnchorElement): string {
    return link.hash.replace(/^#/, "")
  }

  private activate(name: string): void {
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.panel !== name)
    })

    this.tabTargets.forEach((tab) => {
      const isActive = this.tabName(tab) === name
      tab.classList.remove(...TAB_CLASSES["tab-active"], ...TAB_CLASSES["tab-inactive"])
      tab.classList.add(...(isActive ? TAB_CLASSES["tab-active"] : TAB_CLASSES["tab-inactive"]))
      tab.setAttribute("aria-selected", isActive ? "true" : "false")
    })
  }
}
